// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Plan-Beschreibungen sind Klartext aus den Seeds: Absätze durch Leerzeilen,
// Aufzählungen mit "– " oder "- ", oft mit Label-Zeile davor ("Plan-Regeln:").
// Dieser Parser macht daraus Blöcke, die die Plan-Seite sauber setzen kann.

export type BeschreibungsBlock =
  | { art: "absatz"; text: string }
  | { art: "liste"; label: string; punkte: string[] }

const AUFZAEHLUNG = /^[–\-•]\s+/

export function parseBeschreibung(text: string): BeschreibungsBlock[] {
  const bloecke: BeschreibungsBlock[] = []
  for (const roh of text.split(/\n{2,}/)) {
    const zeilen = roh.split("\n").map((z) => z.trim()).filter(Boolean)
    if (!zeilen.length) continue

    const hatPunkte = zeilen.some((z) => AUFZAEHLUNG.test(z))
    if (!hatPunkte) {
      bloecke.push({ art: "absatz", text: zeilen.join(" ") })
      continue
    }

    // Label = führende Zeilen ohne Aufzählungszeichen (z. B. "Plan-Regeln:")
    let label = ""
    const punkte: string[] = []
    for (const z of zeilen) {
      if (AUFZAEHLUNG.test(z)) {
        punkte.push(z.replace(AUFZAEHLUNG, ""))
      } else if (punkte.length === 0) {
        label = label ? `${label} ${z}` : z
      } else {
        // Umbruch mitten im Punkt (Klartext) — an den letzten Punkt anhängen
        punkte[punkte.length - 1] += ` ${z}`
      }
    }
    bloecke.push({ art: "liste", label: label.replace(/:$/, ""), punkte })
  }
  return bloecke
}
